import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { SpeakerType } from '../../../models/speaker/speaker-type';

@Injectable({
  providedIn: 'root'
})
export class SpeakerTypeService {

  speakerTypeUrl: string;
  constructor(private http: HttpClient) {
    this.speakerTypeUrl = environment.baseURI + environment.apiUrl + 'speaker/getAllSpeakerTypes';
  }

  getAllSpeakerTypes(): Observable<SpeakerType> {
    return this.http.get<SpeakerType>(this.speakerTypeUrl);
  }
}
